import styles from "./Terminal.module.css";
import CyberFox from "../UI/CyberFox/CyberFox";
import TerminalInput from "./TerminalInput/TerminalInput";

export default function Terminal() {
  return <div className={styles.terminal}>
    <CyberFox />
    <TerminalInput />
  </div>
}